import { Alert, Button, Result, Skeleton, Space, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';

interface RouteLoadErrorProps {
  readonly onRefresh?: () => void;
  readonly safeReturnTo?: string;
}

export function RouteLoading() {
  return (
    <main aria-label="正在加载页面" aria-live="polite" className="app-loading" role="status">
      <Skeleton active paragraph={{ rows: 4 }} title />
    </main>
  );
}

export function RouteNavigationLoading() {
  return (
    <Alert
      aria-label="正在加载页面"
      aria-live="polite"
      icon={<Spin size="small" />}
      role="status"
      showIcon
      title="正在加载页面，请稍候…"
      type="info"
    />
  );
}

export function RouteLoadError({ onRefresh = refreshPage, safeReturnTo }: RouteLoadErrorProps) {
  const navigate = useNavigate();

  return (
    <section className="content-inner" role="alert">
      <Result
        extra={
          <Space wrap>
            <Button type="primary" onClick={onRefresh}>
              刷新页面
            </Button>
            {safeReturnTo === undefined ? null : (
              <Button
                onClick={() => {
                  void navigate(safeReturnTo, { replace: true });
                }}
              >
                返回上级页面
              </Button>
            )}
          </Space>
        }
        status="warning"
        subTitle="页面所需资源暂时不可用。请稍后刷新页面重试。"
        title="页面暂时无法加载"
      />
    </section>
  );
}

function refreshPage(): void {
  window.location.reload();
}
